import {
  SAVE_TRIP_SUCCESS,
  SET_TRIP_SUCCESS,
  SAVE_TRIP_REDIRECT_RESET,
  UPDATE_TRIP_SUCCESS,
  SUBMIT_TRIP,
  NO_EFFORT_REASON_TRIP,
  SET_TRIP_REDIRECT,
  SET_ERROR,
  SUBMIT_TRIP_SUCCESS,
  SUBMIT_TRIP_ERROR,
  DELETE_TRIP,
  DELETE_EFFORT,
  DELETE_CATCH,
  DELETE_SALES,
  SAVE_OPEN_TRIP_SUCCESS,
  SAVE_NEW_TRIP_SUCCESS,
} from "./actionTypes";
import { getOpenVtrTrips } from "./vtrTripStorage";

export const setRedirect = () => {
  return {
    type: SET_TRIP_REDIRECT,
  };
};
export const setTrip = (client_id) => {
  if (!client_id) {
    console.error("setTrip", "no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  return {
    type: SET_TRIP_SUCCESS,
    client_id,
  };
};
export const saveTrip = (response, client_id) => {
  console.log("saveNewTrip", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("saveTrip", "no trip data provided");
    return {
      type: SET_ERROR,
      error: "no trip data provided",
    };
  }
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  return {
    type: SAVE_TRIP_SUCCESS,
    meta: response,
    client_id: client_id,
  };
};
export const updateOpenTrip = (response, client_id) => {
  console.log("updateOpenTrip", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("updateOpenTrip", "no trip data provided");
    return {
      type: SET_ERROR,
      error: "no trip data provided",
    };
  }
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  return {
    type: SAVE_OPEN_TRIP_SUCCESS,
    meta: response,
    client_id: client_id,
  };
};
export const newOpenTrip = (response, client_id) => {
  console.log("newOpenTrip", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("newOpenTrip", "no trip data provided");
    return {
      type: SET_ERROR,
      error: "no trip data provided",
    };
  }
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  return {
    type: SAVE_NEW_TRIP_SUCCESS,
    meta: response,
    client_id: client_id,
  };
};

export const setCurrentTrip = (response, client_id) => {
  console.log("setCurrentTrip", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("setCurrentTrip", "no trip data provided");
    return {
      type: SET_ERROR,
      error: "no trip data provided",
    };
  }
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  return {
    type: SET_TRIP_SUCCESS,
    meta: response,
    client_id: client_id,
  };
};

export const updateTrip = (response, client_id, trip_id) => {
  console.log("updateTrip", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("updateTrip", "no data provided");
    return {
      type: SET_ERROR,
      error: "no trip data provided",
    };
  }
  if (!client_id) {
    console.error("updateTrip", "no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  if (!trip_id) {
    console.error("updateTrip", "no trip id provided");
    return {
      type: SET_ERROR,
      error: `No trip id provided for Permit# [${response.vessel_permit_num}], on Date [${response.date_sail}] `,
    };
  }
  return {
    type: UPDATE_TRIP_SUCCESS,
    meta: response,
    client_id: client_id,
    trip_id: trip_id,
  };
};

export const resetTripRedirect = () => {
  return {
    type: SAVE_TRIP_REDIRECT_RESET,
  };
};

export const deleteSales = (event) => {
  event.preventDefault();
  let client_id = event.currentTarget.dataset.client_id;
  let trip_id = event.currentTarget.dataset.trip_id;
  let sales_id = event.currentTarget.dataset.sales_id;
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  if (!sales_id) {
    console.error("no sales id provided");
    return {
      type: SET_ERROR,
      error: "no sales id provided",
    };
  }
  return {
    type: DELETE_SALES,
    client_id,
    trip_id,
    sales_id,
  };
};
export const deleteCatch = (event) => {
  event.preventDefault();
  let client_id = event.currentTarget.dataset.client_id;
  let trip_id = event.currentTarget.dataset.trip_id;
  let effort_id = event.currentTarget.dataset.effort_id;
  let catch_id = event.currentTarget.dataset.catch_id;

  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  if (!effort_id) {
    console.error("no effort id provided");
    return {
      type: SET_ERROR,
      error: "no effort id provided",
    };
  }
  if (!catch_id) {
    console.error("no catch id provided");
    return {
      type: SET_ERROR,
      error: "no catch id provided",
    };
  }
  return {
    type: DELETE_CATCH,
    client_id,
    trip_id,
    effort_id,
    catch_id,
  };
};
export const deleteEffort = (event) => {
  event.preventDefault();
  let client_id = event.currentTarget.dataset.client_id;
  let trip_id = event.currentTarget.dataset.trip_id;
  let effort_id = event.currentTarget.dataset.effort_id;
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  if (!effort_id) {
    console.error("no effort id provided");
    return {
      type: SET_ERROR,
      error: "no effort id provided",
    };
  }
  return {
    type: DELETE_EFFORT,
    client_id,
    trip_id,
    effort_id,
  };
};
export const deleteTrip = (event) => {
  event.preventDefault();
  let client_id = event.currentTarget.dataset.client_id;
  let trip_id = event.currentTarget.dataset.trip_id;
  if (!client_id) {
    console.error("no client id provided");
    return {
      type: SET_ERROR,
      error: "no client id provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  return {
    type: DELETE_TRIP,
    client_id: client_id,
    trip_id: trip_id,
  };
};

export const submitTrip = (client_id, token, trip, trip_id, test_user) => {
  if (!client_id | !token) {
    console.error("no client id or token provided");
    return {
      type: SET_ERROR,
      error: "no client id or token provided",
    };
  }
  if (!trip || Object.keys(trip).length === 0) {
    console.error("no trip provided");
    return {
      type: SET_ERROR,
      error: "no trip provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  console.log(test_user);
  if (test_user === undefined) {
    console.error("no test user indicator provided");
    return {
      type: SET_ERROR,
      error: "no test user indicator provided",
    };
  }
  let sales_trip = true;
  if (
    trip.hasOwnProperty("sales") &&
    Array.isArray(trip.sales) &&
    trip.sales.length === 0
  ) {
    sales_trip = false;
  }
  return {
    type: SUBMIT_TRIP,
    meta: trip,
    test_user: test_user,
    client_id: client_id,
    token: token,
    trip_id: trip_id,
    sales_trip: sales_trip,
  };
};
export const submitTripSuccess = ({ client_id, trip_id, data }) => {
  return { type: SUBMIT_TRIP_SUCCESS, client_id, trip_id, data };
};

export const submitTripError = ({ error, trip_id, client_id }) => {
  return {
    type: SUBMIT_TRIP_ERROR,
    error,
    trip_id,
    client_id,
  };
};

export const setTripNoEffortReason = (response, client_id, trip_id) => {
  console.log("setTripNoEffortReason", response);
  if (!response || Object.keys(response).length === 0) {
    console.error("setTripNoEffortReason", "no effort data provided");
    return {
      type: SET_ERROR,
      error: "no effort data provided",
    };
  }
  if (!client_id) {
    console.error("no client_id provided");
    return {
      type: SET_ERROR,
      error: "no client_id provided",
    };
  }
  if (!trip_id) {
    console.error("no trip id provided");
    return {
      type: SET_ERROR,
      error: "no trip id provided",
    };
  }
  return {
    type: NO_EFFORT_REASON_TRIP,
    meta: response,
    client_id: client_id,
    trip_id: trip_id,
  };
};

export const checkTripIdExist = function (newTripId, client_id) {
  const allOpenTrips = getOpenVtrTrips(client_id, null, true);
  if (allOpenTrips && allOpenTrips.length > 0) {
    for (let e = 0; e < allOpenTrips.length; e++) {
      if (allOpenTrips[e].hasOwnProperty("trip_id") && allOpenTrips[e].trip_id) {
        if (allOpenTrips[e].trip_id === newTripId) {
          return true;
        }
      }
    }
  }
  return false;
};

export const createTripId = function (newTripId, dateSail, vesselPermitNr) {
  let genTripId = null;
  if (newTripId === null) {
    let dateTimeSail = new Date(dateSail);
    let sailYear = dateTimeSail.getFullYear().toString().substring(2, 4);
    let sailMonth = dateTimeSail.getMonth() + 1;
    let sailDate = dateTimeSail.getDate();
    let sailHour = dateTimeSail.getHours();
    if (sailMonth < 10) {
      sailMonth = "0" + sailMonth;
    }
    if (sailDate < 10) {
      sailDate = "0" + sailDate;
    }
    if (sailHour < 10) {
      sailHour = "0" + sailHour;
    }
    genTripId = vesselPermitNr + sailYear + sailMonth + sailDate + sailHour;
  } else {
    let generatedTime = new Date(dateSail);
    let generatedYear = generatedTime.getFullYear().toString().substring(2, 4);
    let generatedMonth = generatedTime.getMonth() + 1;
    let generatedDay = "";
    let generatedHour = "";

    if (generatedTime.getHours() === 23) {
      //next day
      generatedHour = 0;
      generatedDay = generatedTime.getDate() + 1;
      if (generatedTime.getDate() + 1 > 28) {
        //based on Month we need to add a month / year
        if (
          (generatedTime.getMonth() === 1 && generatedTime.getDate() + 1 === 29) ||
          (generatedTime.getMonth() in [3, 5, 8, 10] &&
            generatedTime.getDate() + 1 === 31) ||
          (generatedTime.getMonth() in [0, 2, 4, 6, 7, 9, 11] &&
            generatedTime.getDate() + 1 === 32)
        ) {
          generatedDay = 1;
          generatedMonth = generatedTime.getMonth() + 1;
        } else if (
          generatedTime.getMonth() === 11 &&
          generatedTime.getDate() + 1 === 32
        ) {
          //32 December is first day January next year
          generatedDay = 1;
          generatedMonth = 1;
          generatedYear = (generatedTime.getFullYear() + 1).toString().substring(2, 4);
        }
      }
    } else {
      generatedHour = generatedTime.getHours();
      generatedDay = generatedTime.getDate();
      generatedMonth = generatedTime.getMonth() + 1;
      generatedYear = generatedTime.getFullYear().toString().substring(2, 4);
    }

    if (generatedDay < 10) {
      generatedDay = "0" + generatedDay;
    }
    if (generatedMonth < 10) {
      generatedMonth = "0" + generatedMonth;
    }
    if (generatedHour < 10) {
      generatedHour = "0" + generatedHour;
    }
    genTripId =
      vesselPermitNr + generatedYear + generatedMonth + generatedDay + generatedHour;
  }
  return genTripId;
};

/**
 * Creates a standardized trip ID based on a vessel permit number and a date.
 *
 * @param {string | null} existingTripId - If null, generates an ID for the given date. Otherwise, generates an ID for the next hour.
 * @param {string | Date} dateSail - The sailing date.
 * @param {string | number} vesselPermitNumber - The vessel's permit number.
 * @returns {string} The generated trip ID.
 */
export const createTripIdRefactored = (existingTripId, dateSail, vesselPermitNumber) => {
  // 1. Create a new Date object from the input.
  const targetDate = new Date(dateSail);
  // 2. If an existingTripId is provided, increment the date by one hour.
  // The Date object will automatically handle all day, month, and year rollovers.
  if (existingTripId !== null) {
    targetDate.setHours(targetDate.getHours() + 1);
  }

  // 3. Extract and format date components using modern, clean methods.
  const year = targetDate.getFullYear().toString().slice(-2);
  const month = String(targetDate.getMonth() + 1).padStart(2, "0"); // .getMonth() is 0-indexed
  const day = String(targetDate.getDate()).padStart(2, "0");
  const hour = String(targetDate.getHours()).padStart(2, "0");

  // 4. Assemble and return the final trip ID.
  return `${vesselPermitNumber}${year}${month}${day}${hour}`;
};
